/*
 * 首页模块接口
 */

import { post, get,  put, del } from 'api/http'

export default {
    // 项目动态 操作流程记录
    getLog(data) {
        return get('/log/query', data)
    },

    // 通知公告列表
    getAnnouncementList(data) {
        return post('/announcement/query', data)
    },

    // 通知公告详情
    getAnnouncementDetail(data) {
        return post('/announcement/detail', data)
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/ems/project.js